import React, { useState } from 'react';
import {
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Button,
  Card,
  CardContent,
  FormControlLabel,
} from '@mui/material';



interface RoleFormProps {
  roleData?: {
    id: string;
    name: string;
    description: string;
    isAdminRole: boolean;
    type: 'Internal' | 'External';
    permissions: string[];
  };
  permissions: Record<string,string>;
  onSave: (id: string, role: any) => void;
  onCancel: () => void;
}

const RoleForm: React.FC<RoleFormProps> = ({
  roleData,
  permissions,
  onSave,
  onCancel
}) => {
    
  const [name, setName] = useState(roleData?.name || '');
  const [description, setDescription] = useState(roleData?.description || '');
  const [isAdminRole, setIsAdminRole] = useState(
    roleData?.isAdminRole || false
  );
  const [roleType, setRoleType] = useState<'internal' | 'external'>(
    roleData?.type || 'external'
  );
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>(
    roleData?.permissions || []
  );
  

  const handlePermissionToggle = (permissionId: string) => {
    setSelectedPermissions((prev) =>
      prev.includes(permissionId)
        ? prev.filter((id) => id !== permissionId)
        : [...prev, permissionId]
    );
  };

  const handleSave = () => {
    let data = {}
    selectedPermissions.map(perm => {
    data[perm] =  true
    })
    const role = {
      name,
      description,
      isAdminRole,
      type: roleType,
      permissions: data,
    };
    onSave(roleData.id,role);
  };

  return (
    <Card>
      <CardContent className="space-y-6">
        <Typography variant="h6" className="font-semibold text-gray-800">
          {roleData ? 'Edit Role' : 'Add New Role'}
        </Typography>
        {/* Role Name */}
        <TextField
          fullWidth
          label="Role Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="bg-gray-50"
        />
        {/* Description */}
        <TextField
          fullWidth
          label="Description"
          multiline
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="bg-gray-50"
        />
        {/* Admin Role */}
        <FormControl fullWidth className="bg-gray-50">
          <InputLabel>Admin Role</InputLabel>
          <Select
            value={isAdminRole.toString()}
            onChange={(e) => setIsAdminRole(e.target.value === 'true')}
          >
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </FormControl>
        {/* Role Type */}
        <FormControl fullWidth className="bg-gray-50">
          <InputLabel>Role Type</InputLabel>
          <Select
            value={roleType}
            onChange={(e) => setRoleType(e.target.value as 'internal' | 'external')}
          >
            <MenuItem value="internal">Internal</MenuItem>
            <MenuItem value="external">External</MenuItem>
          </Select>
        </FormControl>
        {/* Permissions */}
        <Typography variant="subtitle1" className="text-gray-600 font-medium">
          Permissions
        </Typography>
        <List>
          {Object.keys(permissions).map((key) => (
            <ListItem
              key={key}
              className="flex justify-between items-center"
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedPermissions.includes(key)}
                    onChange={() => handlePermissionToggle(key)}
                  />
                }
                label={key}
              />
              <ListItemText
                secondary={permissions[key]}
                className="text-gray-500 text-sm"
              />
            </ListItem>
          ))}
        </List>
        {/* Actions */}
        <div className="flex justify-end space-x-4">
          <Button onClick={onCancel} variant="outlined" color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={!name || selectedPermissions.length === 0}
          >
            Save Role
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default RoleForm;
